import { BasicLayout, BlankLayout } from '@/layout'

const orderRouter = {
  path: '/order',
  name: 'Order',
  alwaysShow: true,
  component: BasicLayout,
  redirect: 'noRedirect',
  meta: { title: '订单管理', icon: 'el-icon-s-order' },
  children: [
    // {
    //   path: 'index',
    //   name: 'OrderIndex',
    //   meta: { title: '订单列表' },
    //   component: () => import('@/views/order/index')
    // },
    {
      path: 'gift',
      component: BlankLayout, // Parent router-view
      name: 'GiftOrder',
      meta: { title: '特权礼包', breadcrumb: false },
      redirect: '/order/gift/list',
      children: [
        {
          path: 'list',
          name: 'GiftOrderList',
          meta: { title: '特权礼包订单' },
          component: () => import('@/views/order/gift/list')
        }
      ]
    },
    {
      path: 'welfare',
      component: BlankLayout, // Parent router-view
      name: 'WelfareOrder',
      meta: { title: '福利商城', breadcrumb: false },
      redirect: '/order/welfare/list',
      children: [
        {
          path: 'list',
          name: 'WelfareOrderList',
          meta: { title: '福利商城订单' },
          component: () => import('@/views/order/welfare/list')
        }
      ]
    },
    {
      path: 'point',
      component: BlankLayout, // Parent router-view
      name: 'PointOrder',
      meta: { title: '积分商城', breadcrumb: false },
      redirect: '/order/point/list',
      children: [
        {
          path: 'list',
          name: 'PointOrderList',
          meta: { title: '积分商城订单' },
          component: () => import('@/views/order/point/list')
        }
      ]
    },
    {
      path: 'premium',
      component: BlankLayout, // Parent router-view
      name: 'PremiumOrder',
      meta: { title: '优品商城', breadcrumb: false },
      redirect: '/order/premium/list',
      children: [
        {
          path: 'list',
          name: 'PremiumOrderList',
          meta: { title: '优品商城订单' },
          component: () => import('@/views/order/premium/list')
        }
      ]
    },
    {
      path: 'refund',
      component: BlankLayout, // Parent router-view
      name: 'RefundList',
      meta: { title: '退货退款列表', breadcrumb: false },
      redirect: '/order/refund/list',
      children: [
        {
          path: 'list',
          name: 'RefundOrderList',
          meta: { title: '退货退款列表' },
          component: () => import('@/views/order/refund/list')
        }
      ]
    }
  ]
}

export default orderRouter
